export enum EWebsocketClientEvents {
  WsClientError = 'WsClientError',
  WsClientOpen = 'WsClientOpen',
  WsClientClosed = 'WsClientClosed',
}

export enum EConnectionEvents {
  HandshakeStart = 'HandshakeStart',
  HandshakeComplete = 'HandshakeComplete',
  ConnectionRemoved = 'ConnectionRemoved',
  ConnectionAdded = 'ConnectionAdded',
}

export enum ERTCEvents {
  PeerSignal = 'PeerSignal',
  StreamUpdate = 'StreamUpdate',
}

export enum EStreamSessionEvents {
  SessionUpdated = 'SessionUpdated',
}

export type TAllEvents = EWebsocketClientEvents | EConnectionEvents | ERTCEvents | EStreamSessionEvents;

export type TWebSocketMessage = {
  action: EConnectionEvents | ERTCEvents | EStreamSessionEvents;
  from?: string;
  to?: string[];
  data: Record<string, unknown> | RTCSessionDescriptionInit | RTCIceCandidate;
};
